import { Component, Input, OnInit } from '@angular/core';

import { IProposal } from '@app/activo2/manage-vacations/manage-vacations.interface';
import { VacationsSeason, MotSeasonProposal } from '@app/activo2/manage-vacations/manage-vacations.model';

@Component({
  selector: 'app-resume',
  templateUrl: './resume.component.html',
  styleUrls: ['./resume.component.scss']
})
export class ResumeComponent implements OnInit {
  @Input() selectedSeason!: VacationsSeason;
  @Input() slots!: IProposal[];
  @Input() proposal!: MotSeasonProposal;

  ngOnInit(): void {
    if (this.proposal.checkProposalAlreadyAdded(this.slots)) {
      return;
    }

    const emptyProposalOrderIndex = this.proposal.proposalsByOrder.findIndex(
      (orderedProposal) => !orderedProposal.proposals.length
    );

    this.slots.forEach((slot) => (slot.order = emptyProposalOrderIndex + 1));
    this.proposal.addSlotsToSeasonProposal(this.slots);
    this.proposal.groupProposalsByOrder();
  }
}
